import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';
// import { ToggleElement, buildThumbnailUrl } from '@bd/bdcore-utilities';
import withData from '@bd/bdcore-data';
import { colors, typography } from '../styles';
import HeaderMenu from './HeaderMenu';
import ContactModal from './ContactModal';
// import Search from './Search';

const styles = css`
  height: 60px;
  width: 100%;

  @media (min-width: 991px) {
    height: 100px;
  }

  .Header {
    display:flex;
    flex-flow:row nowrap;
    justify-content: space-between;
    align-items: center;
    background-color: ${colors.color1};
    height: 60px;
    position: fixed;
    top:0;
    width: 100%;
    z-index: 50;
    @media (min-width: 991px) {
      height: 100px;
    }

  .Header_logo {
    display:flex;;
    flex-flow:column wrap;
    justify-content: center;
    width: 172px;
    height: auto;
    padding:0 10px;
    @media (min-width: 991px) {
      padding:0 20px;
      width: 300px;
    }
    img {
      max-width: 100%;
    }
  }
  .Header_search {
    z-index: 2;
    border-left:1px solid #eee;
    @media (min-width: 991px) {
    }
  }
  .Header_search span {
    content: " ";
    display: block;
    width: 50px;
    height: 60px;
    border: 0;
    background-image: url('/images/icon-search.svg');
    background-position: center center;
    background-repeat: no-repeat;
    background-size: auto 24px;
    @media (min-width: 991px) {
      height: 100px;
      width: 100px;
    }
    &:focus {
      background-color: ${colors.color1};
      background-image: url('/images/icon-search-white.svg');
      outline: 0;
      box-shadow: 0;
    }
  }
  .Header_searchResults {
    width: 100%;
    background-color: ${colors.color1};
    padding: 15px 0 25px 0;
    position: fixed;
    top: 60px;
    left: 0;
    @media (min-width: 991px) {
      right: 0;
      top: 100px;
      left: auto;
      padding: 45px 0 65px 0;
    }
    h3 {
      font-size: 20px;
      color: #FFFFFF;
      margin: 0 0 15px 0;
      font-family: ${typography.SansSerif};
      @media (min-width: 991px) {
        font-size: 28px;
      }
    }
    input {
      width: 100%;
      padding: 4px 8px;
    }
    .results {
      list-style: none;
      margin: 10px 0 0 0;
      padding: 10px 0;
      height: 200px;
      overflow-y: scroll;
      background-color: #FFFFFF;
      a {
        display: block;
        padding: 10px 10px;
        font-size: 15px;
        line-height: 1.1;
        font-weight: 700;
        &:hover {
          background-color: #EFEFEF;
        }
      }
    }
  }
  .Header_menuToggle {
    width: 60px;
    height: 60px;
    border: 0;
    background: transparent url('/images/icon-menu.svg');
    background-position: center center;
    background-repeat: no-repeat;
    padding: 0;
    margin: 0;
    margin: 0;
    background-size: 36px;
    @media (min-width: 991px) {
      width: 100px;
      height: 100px;
      margin: 0;
      background-size: auto;
    }
  }
  .OSCTag {
      display:none;

      @media (min-width: 991px) {
        display: block;
        position: relative;
        bottom:auto;
        top:0;
        right:0;
        left:auto;
        height:100px;
        width:250px;
        background:${colors.color2};
        cursor:pointer;
      }

      .OSCTag_Headline {
        display: flex;
        flex-flow:column nowrap;
        justify-content: center;
        height:50%;
        width:100%;
        padding:0 0 0 20px;
        font:700 20px/30px ${typography.SansSerif};
        color:white;
      }
      .OSCTag_Actions {
        height:50%;
        display: flex;
        flex-flow:row nowrap;
        justify-content: center;
        color:white;

        a.OSCTag_Actions-icon, span.OSCTag_Actions-icon {
          flex-grow: 1;
          font-weight:700;
          color:white;
          background:${colors.color2Darker};
          display:flex;
          flex-flow:column nowrap;
          justify-content: center;
          text-align: center;
          border-right:1px solid ${colors.color2};

          img {
            width:32px;
            height:32px;
            margin:0 auto;
          }
        }
      }

    }
    .HeaderTools_Wrap {
      display: flex;
      flex-flow:row nowrap;
      justify-content: center;
    }
  }
`;

class Header extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      menuActive: false,
    };
  }

  toggleMenu = () => {
    this.setState({
      menuActive: !this.state.menuActive,
    });
  }

  render() {
    const { widget } = this.props;
    const { builder } = this.props;
    const { menuActive } = this.state;
    return (
      <div className={styles}>
        <div className="Header">
          <div className="Header_logo">
            <Link name="index">
              <img src="/images/blockone-logo-white-red.svg" alt={builder.name} />
            </Link>
          </div>
          <a className="btn-reverse" href="https://hosted.usiopay.com/63f9d750-4435-43f1-abfb-8c042931ed39" target="_blank" rel="noopener noreferrer">
            Pay HOA Dues
          </a>
          <div className="HeaderTools_Wrap">
            <button className="Header_menuToggle" onClick={this.toggleMenu} />
            <HeaderMenu isActive={menuActive} toggleMenu={this.toggleMenu} builder={builder} />
            {/* <div className="Header_search">
              <ToggleElement
                className="Header_searchButton"
              >
                <Search className="Header_searchResults" />
              </ToggleElement>
            </div> */}
            <ContactModal>
              <div className="OSCTag">
                <div className="OSCTag_Headline">
                  {widget.headline}
                </div>
                <div className="OSCTag_Actions">
                  {/* <a href={`tel:${get(builder, 'telephone').replace(/[^0-9]/g, '')}`}
                   className="OSCTag_Actions-icon"><img src="/images/icon-phone-white.svg"
                    alt="" /></a> */}
                  <a href={`tel:${get(builder, 'telephone').replace(/[^0-9]/g, '')}`} className="OSCTag_Actions-icon">{get(builder, 'telephone').replace(/\s-\s/, '-')}</a>
                  {/* <a href={`sms:${get(builder, 'text_phone').replace(/[^0-9]/g, '')}`}
                   className="OSCTag_Actions-icon"><img src="/images/icon-sms-white.svg"
                    alt="" /></a> */}
                  <span className="OSCTag_Actions-icon"><img src="/images/icon-email-white.svg" alt="" /></span>
                </div>
              </div>
            </ContactModal>
          </div>
          {/* <ContactModal builder={builder}>
            <div className="OSCTag_wrapper">
              <div className="OSCTag_image" />
              <div className="OSCTag_content">
                <div className="OSCTag_headline">
                  Ask {builder.name}!
                </div>
                <div className="OSCTag_phone">
                  {builder.telephone}
                </div>
              </div>
            </div>
          </ContactModal> */}
        </div>
      </div>
    );
  }
}

Header.propTypes = {
  builder: PropTypes.object.isRequired,
  widget: PropTypes.object.isRequired,
};

export default withData(
  {
    builder: true,
    widget: 'online_sales_consultant',
  },
)(Header);



// WEBPACK FOOTER //
// ./src/components/Header.js